'use client';

import { selectCustomRouteElevationData } from '@alltrails/maps/redux/customRoute';
import type { ElevationPoint } from '@alltrails/maps/types/Geo';
import { useAppSelector } from '../redux';

const EMPTY_ELEVATION_DATA: ElevationPoint[][] = [];

type PrintElevation = {
  elevationData: ElevationPoint[][];
  elevationGain?: number;
  elevationLoss?: number;
};

const usePrintElevation = (): PrintElevation => {
  const { elevationData, elevationGain, elevationLoss } = useAppSelector(state => ({
    elevationData: state.customRoute ? selectCustomRouteElevationData({ customRoute: state.customRoute }) : EMPTY_ELEVATION_DATA,
    elevationGain: state.customRoute?.route.elevationGain,
    elevationLoss: state.customRoute?.route.elevationLoss
  }));

  return {
    elevationData,
    elevationGain,
    elevationLoss
  };
};

export default usePrintElevation;
